import axios from 'axios'
import config from '@assets/config.json' // api 请求json

const state = {
	hostExhibition: null, // 主办后台展会信息
}
const mutations = {
	setHostExhibition(state, data) {
		state.hostExhibition = data
	},
}
const getters = {
	getHostExhibition: (state) => {
		return state.hostExhibition
	},
	getHostExhibitionId: (state) => {
		return state.hostExhibition ? state.hostExhibition.id : ''
	},
}
const actions = {
	// 会刊免费登记 列表
	async journalFreeRecordList({ dispatch }, opt) {
		const query = `
    query($query: JournalFreeRecordPagedQueryInput! ){
        journalFreeRecord{
            page(query:$query){
                page
                size
                hasPreviousPage
                hasNextPage
                totalCount
                totalPages
                items {
                  exhibitorId
                  name
                  nameEn
                  address
                  contractName
                  tel
                  fax
                  email
                  postcode
                  introduction
                  introductionEn
                  creationTime
                  creatorId
                  id
                  exhibitor{
                    exhibitorName
                    id
                    boothJson
                    exhibitionArea
                    exhibitionId
                    id
                    userId
                  }
                }
                }
            }
        }
    `
		const body = {
			queryName: 'journalFreeRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data && data.data.journalFreeRecord.page
				? data.data.journalFreeRecord.page
				: null
		return Promise.resolve(bool || null)
	},

	// 展位楣板信息登记 列表
	async lintelRecordList({ dispatch }, opt) {
		const query = `
    query($query: LintelRecordPagedQueryInput!){
        lintelRecord{
            page(query:$query){
                page
                size
                hasPreviousPage
                hasNextPage
                totalCount
                totalPages
                items {
                  exhibitorId
                  name
                  nameEn
                  isDeleted
                  deleterId
                  deletionTime
                  lastModificationTime
                  lastModifierId
                  creationTime
                  creatorId
                  id
                  exhibitor{
                    exhibitorName
                    id
                    boothJson
                    exhibitionArea
                    exhibitionId
                    id
                    userId
                  }
                }
                }
            }
        }
    `
		const body = {
			queryName: 'lintelRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data && data.data.lintelRecord.page
				? data.data.lintelRecord.page
				: null
		return Promise.resolve(bool || null)
	},
	// 胸卡 列表
	async cardRecordList({ dispatch }, opt) {
		const query = `
  query($query: CardRecordPagedQueryInput! ){
    cardRecord {
        page(query:$query){
            page
            size
            hasPreviousPage
            hasNextPage
            totalCount
            totalPages
            items {
              exhibitorId
              name
              idCardNo
              gender
              phoneNumber
              department
              jobTitle
              isDeleted
              deleterId
              deletionTime
              lastModificationTime
              lastModifierId
              creationTime
              creatorId
              id
              exhibitor{
                exhibitorName
                id
                boothJson
                exhibitionArea
                exhibitionId
                id
                userId
              }
            }
            }
        }
    }
`
		const body = {
			queryName: 'cardRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data && data.data.cardRecord.page ? data.data.cardRecord.page : null
		return Promise.resolve(bool || null)
	},

	// 会刊广告 列表
	async journalAdvertRecordList({ dispatch }, opt) {
		const query = `
  query($query:  JournalAdvertRecordPagedQueryInput! ){
    journalAdvertRecord {
        page(query:$query){
            page
            size
            hasPreviousPage
            hasNextPage
            totalCount
            totalPages
            items {
                exhibitorId
                address
                postcode
                tel
                fax
                contractName
                preBookJson
                otherRemark
                isDeleted
                deleterId
                deletionTime
                lastModificationTime
                lastModifierId
                creationTime
                creatorId
                id
                exhibitor{
                    exhibitorName
                    id
                    boothJson
                    exhibitionArea
                    exhibitionId
                    id
                    userId
                }
               }
            }
        }
    }
`
		const body = {
			queryName: 'journalAdvertRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data && data.data.journalAdvertRecord.page
				? data.data.journalAdvertRecord.page
				: null
		return Promise.resolve(bool || null)
	},
	// 展品信息管理 列表
	async exhibitorList({ dispatch }, opt) {
		const query = `
  query($query:ExhibitorPagedQueryInput! ){
    exhibitor {
        page(query:$query){
            page
            size
            hasPreviousPage
            hasNextPage
            totalCount
            totalPages
            items {
                exhibitionId
                exhibitorName
                exhibitionArea
                boothJson
                userId
                id
                totals {
                  extendedProperties
                  exhibitorId
                  key
                  creationTime
                  lastModificationTime
                }
                receiptRecords {
                  exhibitorId
                  itemId
                  fileName
                  fileUrl
                  isDeleted
                  deleterId
                  deletionTime
                  lastModificationTime
                  lastModifierId
                  creationTime
                  creatorId
                  id
                  exhibitor{
                    exhibitionId 
                    exhibitorName 
                    exhibitionArea
                    boothJson 
                    userId 
                    id
                  }
                }
                applicationRanges {
                  itemId
                  treeName
                  name
                  nameEn
                }
                categories {
                  itemId
                  treeName
                  name
                  nameEn
                }
            }
            }
        }
    }
`
		const body = {
			queryName: 'exhibitorList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data && data.data.exhibitor.page ? data.data.exhibitor.page : null
		return Promise.resolve(bool || null)
	},

	// 标展搭建变更管理 列表
	async standardBoothConstructionChangeRecordList({ dispatch }, opt) {
		const query = `
  query($query:StandardBoothConstructionChangeRecordPagedQueryInput!){
    standardBoothConstructionChangeRecord {
        page(query:$query){
            page
            size
            hasPreviousPage
            hasNextPage
            totalCount
            totalPages
            items {
              exhibitorId
              preBookJson
              otherRemark
              isDeleted
              deleterId
              deletionTime
              lastModificationTime
              lastModifierId
              creationTime
              creatorId
              id
              exhibitor{
                exhibitorName
                id
                boothJson
                exhibitionArea
                exhibitionId
                id
                userId
              }
            }
            }
        }
    }
`
		const body = {
			queryName: 'standardBoothConstructionChangeRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data && data.data.standardBoothConstructionChangeRecord.page
				? data.data.standardBoothConstructionChangeRecord.page
				: null
		return Promise.resolve(bool || null)
	},

	// 租凭管理 列表
	async rentedFurnitureAndTelecommunicationsServiceRecordList(
		{ dispatch },
		opt
	) {
		const query = `
  query($query:RentedFurnitureAndTelecommunicationsServiceRecordPagedQueryInput!){
    rentedFurnitureAndTelecommunicationsServiceRecord {
        page(query:$query){
            page
            size
            hasPreviousPage
            hasNextPage
            totalCount
            totalPages
            items {
              exhibitionId
              exhibitorName
              exhibitionArea
              boothJson
              userId
              itemName
              exhibitorId
              itemId
              number
              amount
              isDeleted
              deleterId
              deletionTime
              lastModificationTime
              lastModifierId
              creationTime
              creatorId
              id
            }
            }
        }
    }
`
		const body = {
			queryName: 'rentedFurnitureAndTelecommunicationsServiceRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data &&
			data.data.rentedFurnitureAndTelecommunicationsServiceRecord.page
				? data.data.rentedFurnitureAndTelecommunicationsServiceRecord
						.page
				: null
		return Promise.resolve(bool || null)
	},

	// 展台拆除/安装管理 列表
	async demolitionBoothAndInstallationConstructionRecordList(
		{ dispatch },
		opt
	) {
		const query = `
  query($query: DemolitionBoothAndInstallationConstructionRecordPagedQueryInput!){
    demolitionBoothAndInstallationConstructionRecord {
        page(query:$query){
            page
            size
            hasPreviousPage
            hasNextPage
            totalCount
            totalPages
            items {
              exhibitionId
              exhibitorName
              exhibitionArea
              boothJson
              userId
              itemName
              exhibitorId
              itemId
              number
              amount
              isDeleted
              deleterId
              deletionTime
              lastModificationTime
              lastModifierId
              creationTime
              creatorId
              id
            }
            }
        }
    }
`
		const body = {
			queryName: 'demolitionBoothAndInstallationConstructionRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data &&
			data.data.demolitionBoothAndInstallationConstructionRecord.page
				? data.data.demolitionBoothAndInstallationConstructionRecord
						.page
				: null
		return Promise.resolve(bool || null)
	},

	// 导出
	async scheduleJobGql({ dispatch }, opt) {
		const query = `#graphql
        mutation($input:ScheduleJobCreateCommandInput!){
            scheduleJob{
                create  (input:$input)
            }
        }
    `
		const body = {
			queryName: 'scheduleJobGql',
			query: query,
			variables: {
				input: {
					...opt,
				},
			},
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data && data.data.scheduleJob.create
				? data.data.scheduleJob.create
				: null
		return Promise.resolve(bool || null)
	},



	//数据维护列表
	async scheduleJobList(
		{ dispatch },
		opt
	) {
		const query = `
          query($query:ScheduleJobPagedQueryInput!){
            scheduleJob {
                page(query:$query){
                    page
                    size
                    hasPreviousPage
                    hasNextPage
                    totalCount
                    totalPages
                    items {
                      extendedProperties
                      customTag
                      taskCode
                      name
                      taskState
                      taskStateTime
                      tryCount
                      lastTryTime
                      nextTryTime
                      isAbandoned
                      completedTime
                      priority
                      isDeleted
                      deleterId
                      deletionTime
                      lastModificationTime
                      lastModifierId
                      creationTime
                      creatorId
                      id
                    }
                    }
                }
            }
        `
		const body = {
			queryName: 'scheduleJobList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data &&
			data.data.scheduleJob.page
				? data.data.scheduleJob
						.page
				: null
		return Promise.resolve(bool || null)
	},


    //回执列表详情
	async getreceiptRecordList(
		{ dispatch },
		opt
	) {
		const query = `
          query($query:ReceiptRecordPagedQueryInput! ){
            receiptRecord {
                page(query:$query){
                    page
                    size
                    hasPreviousPage
                    hasNextPage
                    totalCount
                    totalPages
                    items {
                      exhibitorId
                      itemId
                      fileName
                      fileUrl
                      isDeleted
                      deleterId
                      deletionTime
                      lastModificationTime
                      lastModifierId
                      creationTime
                      creatorId
                      id
                      exhibitor{
                        exhibitorName 
                      }
                    }
                    }
                }
            }
        `
		const body = {
			queryName: 'getreceiptRecordList',
			query: query,
			variables: { query: opt },
		}
		const { data } = await dispatch('graphqlPost', body, {
			root: true,
		})
		const bool =
			data &&
			data.data.receiptRecord.page
				? data.data.receiptRecord
						.page
				: null
		return Promise.resolve(bool || null)
	},
 

}
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}
